export enum CardVariantsEnum {
    STANDARD = "standard",
    HEADLINE = "headline",
    LISTING = "listing",
    LISTING_HORIZONTAL = "listing_horizontal",
    CONDENSED = "condensed",
    CONDENSED_SQUARE_THUMB = "condensed_square_thumb",
    HORIZONTAL = "horizontal",
    DISCOVERY = "discovery",
    MINIMAL = "minimal",
    TEXT_WITH_LINK = "text_with_link",
}
